import React from 'react';
import { Button, Flex, Text } from '@radix-ui/themes';
import { DEFAULT_LOGO_SIZE, MIN_LOGO_SIZE, MAX_LOGO_SIZE } from './portalLogoSize';

export default function LogoSizeControl({ value, onChange, disabled = false, label = 'Logo size' }) {
  return (
    <Flex direction="column" gap="2" mt="3">
      <Flex justify="between" align="center">
        <Text size="2" weight="medium">{label}</Text>
        <Text size="2">{value}%</Text>
      </Flex>
      <input
        type="range"
        aria-label={label}
        aria-valuetext={`${value}%`}
        min={MIN_LOGO_SIZE}
        max={MAX_LOGO_SIZE}
        step={5}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        disabled={disabled}
        style={{ width: '100%', accentColor: 'var(--accent-9)', cursor: disabled ? 'not-allowed' : 'pointer' }}
      />
      <Flex justify="between" align="center" gap="2">
        <Text size="1" color="gray">Size is limited to the available space.</Text>
        <Button type="button" size="1" variant="ghost"
          disabled={disabled || value === DEFAULT_LOGO_SIZE}
          onClick={() => onChange(DEFAULT_LOGO_SIZE)}>
          Reset
        </Button>
      </Flex>
    </Flex>
  );
}
